// removed by extract-text-webpack-plugin
module.exports = {"legenda":"_2pW7AgPikjhMWJUlvC1D0P","marked":"_30lnjtFqm6gCwjYDwNkLoA","tagsWeek":"_2R7VcrrRpYI2hS3WBwYZ08","checktag":"_33zu4aE5imfQJQEVuIfpyQ","calendar":"_3iPn-qUreIeBs8ILDcqP9x"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateGym/Steps/Calendar/style.module.css
// module id = 512
// module chunks = 39